import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Countdown from "react-countdown";
import Button from "../../components/common/Button";
import Text from "../../components/common/Text";
import FlexBox from "../../components/common/FlexBox";
import Div from "../../components/common/Div";
import HR from "../../components/common/HR";
import IconBar from "../Partials/IconBar";
import SubmitTestBox from "../Partials/SubmitTestBox";
import Question from "../Tests/Question";
import {
  tenzero,
  urlbase,
  headers,
  NumberToLetter,
  fixOptions,
} from "../../constants/Constants";
import ResultQuestion from "./ResultQuestion";
import ResultContinueBox from "../Partials/ResultContinueBox";
import { Typography, Box } from "@mui/material";

//fixed options save
export default function Results(props) {
  const history = useHistory();
  if (
    props === undefined ||
    props.location === undefined ||
    props.location.state === undefined ||
    props.location.state.user === undefined ||
    props.location.state.test === undefined ||
    props.location.state.questions === undefined ||
    props.location.state.submission === undefined ||
    props.location.state.submissionResults === undefined
  )
    history.push("/login");

  const user = props.location.state.user;
  const test = props.location.state.test;
  const questions = props.location.state.questions;
  const grouptest = props.location.state.grouptest;
  const submission = props.location.state.submission;
  const submissionResults = props.location.state.submissionResults;
  const [showModal, setShowModal] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const numberOfQuestions = questions.length;
  const arr = Array.apply(null, Array(numberOfQuestions)); //.map(function () {}); //mapping the blank method seems redundant, as the array is already populated with undefined's

  function ShowAllResults() {
    //displays all of the questions in the test
    let arr = [];
    for (var i = 0; i < questions.length; i++) {
      //const letter = NumberToLetter(i);
      const curNum = i;
      const value = (
        <div
          style={{
            fontSize: "0.9rem",
            backgroundColor: "rgb(33, 42, 65)",
            padding: "10px",
            paddingBottom: "10px",
            borderRadius: "5px",
            fontWeight: "bold",
            textAlign: "center",
            marginTop: "15px",
          }}
        >
          <ResultQuestion
            question={questions[i]}
            submission={submission}
            questionNumber={i}
            submissionResults={submissionResults}
          />
        </div>
      );
      arr.push(value);
    }
    return <Div>{arr}</Div>;
  }

  function ContinueToMain() {
    return (
      <Div margin={"20px 0px 20px 0px"}>
        <Button
          fontSize={"1.1rem"}
          padding={"15px 15px"}
          width={"100%"}
          marginTop={"15px"}
          borderRadius={"5px"}
          backgroundColor={"#fbcd02"}
          color={"#00112e"}
          fontWeight={"bold"}
          textTransform={"uppercase"}
          onClick={() => {
            setShowModal(true);
          }}
        >
          CLOSE
        </Button>
      </Div>
    );
  }

  return (
    <>
      <div
        style={{ height: "100%", width: windowWidth >= 800 ? "50%" : "90%" }}
      >
        <div className="HeaderBox">
          <IconBar location={"test"} user={user} />
        </div>

        <div
          style={{
            color: "rgb(251, 205, 2)",
            fontSize: "1.1rem",
            paddingTop: "10px",
            paddingBottom: "10px",
            borderRadius: "5px",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          {test.name}
        </div>
        <Div
          padding={"10px"}
          borderRadius={"5px"}
          backgroundColor={"#fbcd02"}
          height={"100%"}
          marginBottom={"10px"}
          style={{ boxSizing: "border-box" }}
        >
          <Typography style={{ fontWeight: "bold", color: "#00112e" }}>
            {" "}
            Results
          </Typography>
        </Div>
        {ShowAllResults()}
        {ContinueToMain()}
      </div>

      <ResultContinueBox
        display={showModal}
        handler1={() => {
          setShowModal(false);
        }}
        handler2={() => {
          history.push("/testdashboard", { user: user });
        }}
      />
    </>
  );
}
